import styled from 'styled-components';
import { DESKTOP_MIN_BREAK, GTM_DATA_ATTRIBUTE } from '#/shared/constants';
import { ClearInput, ClearButton } from '#/shared/components/Styled';
import SvgSearch from '#/shared/components/GeneratedIcons/trimet/Search';
import SvgClose from '#/shared/components/GeneratedIcons/generic/Close';

// The row is here to allow us to add extra indentation on the left/right sides of the input
export const QueryInputRow = styled.div`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  max-width: ${DESKTOP_MIN_BREAK};
  padding: 12px 10px;
`;

export const QueryInput = styled(ClearInput).attrs(props => ({
  'aria-label': props.placeholder,
  [GTM_DATA_ATTRIBUTE]: props.dataGtm,
}))`
  flex: 1;
  padding: 5px 0 0 0;
  margin: 0 0 5px 5px;
  font-size: 1.8em;
  min-width: 0;
  border-bottom: 1px solid ${props => props.theme.inputBorderColor};
  &:focus {
    border-bottom: 1px solid ${props => props.theme.inputBorderColorFocus};
  }
`;

export const SearchIcon = styled(SvgSearch).attrs({
  role: 'presentation',
  width: 18,
  height: 18,
})`
  position: relative;
  top: 5px;
  margin: 0 6px 8px 0;
`;

export const ClearSearchButton = styled(ClearButton).attrs({
  role: 'button',
})`
  flex: 0 0 35px;
  display: flex;
  justify-content: center;
`;

export const ClearSearchIcon = styled(SvgClose).attrs({
  role: 'presentation',
  width: 24,
  height: 24,
})``;
